import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import { List } from '@material-ui/core'
import {
  ExitToApp, 
  AttachMoney,
  DataUsageSharp,
  Settings,
  Notifications,
  History,
  Person,
  FilterList,
  Category
} from '@material-ui/icons';
import { useHistory } from 'react-router-dom';

import { LogoColored as Logo } from './../../assets'

import DrawerSection from './DrawerSection'
import { DRAWER_KEYS, ROUTER } from './../../class/constants'

const DRAWER_SECTIONS = {
  [DRAWER_KEYS.CUSTOMER]: {
    id: DRAWER_KEYS.CUSTOMER,
    tStr: 'customer',
    Icon: Person,
    style: {}
  },
  [DRAWER_KEYS.FINANCIAL]: {
    id: DRAWER_KEYS.FINANCIAL,
    tStr: 'financial',
    Icon: AttachMoney,
    style: {},
    subSections: [
      {
        id: DRAWER_KEYS.BILLING,
        tStr: 'billing',
        Icon: AttachMoney,
        style: { padding: '0 1rem 0 2rem', minHeight: '3rem' }
      },
      {
        id: DRAWER_KEYS.FINANCIAL_CONFIG,
        tStr: 'financialConfig',
        Icon: Settings,
        style: { padding: '0 1rem 0 2rem', minHeight: '3rem' }
      }
    ]
  },
  [DRAWER_KEYS.PLANS]: {
    id: DRAWER_KEYS.PLANS,
    tStr: 'plans',
    Icon: DataUsageSharp,
    style: {}
  },
  [DRAWER_KEYS.PRODUCTS]: {
    id: DRAWER_KEYS.PRODUCTS,
    tStr: 'products',
    Icon: Category,
    style: {}
  },
  [DRAWER_KEYS.FILTERS]: {
    id: DRAWER_KEYS.FILTERS,
    tStr: 'filters',
    Icon: FilterList,
    style: {},
    subSections: [
      {
        id: DRAWER_KEYS.FILTERS_LIST,
        tStr: 'filtersList',
        Icon: FilterList,
        style: { padding: '0 1rem 0 2rem', minHeight: '3rem' }
      },
      {
        id: DRAWER_KEYS.FILTERS_MANAGE,
        tStr: 'filtersManage',
        Icon: Settings,
        style: { padding: '0 1rem 0 2rem', minHeight: '3rem' }
      },
    ]
  },
  [DRAWER_KEYS.NOTIFICATIONS]: {
    id: DRAWER_KEYS.NOTIFICATIONS,
    tStr: 'notifications',
    Icon: Notifications,
    style: {}
  },
  [DRAWER_KEYS.LOG]: {
    id: DRAWER_KEYS.LOG,
    tStr: 'managerLog',
    Icon: History,
    style: {}
  },
  [DRAWER_KEYS.EXIT]: {
    id: DRAWER_KEYS.EXIT,
    tStr: 'exit',
    Icon: ExitToApp,
    style: { color: '#292929', background: '#b2b2b2' }
  },
}

function DrawerContent({ classes, selectedKey, onSelect }) {
  const [sections] = useState(
    Object.values(DRAWER_SECTIONS)
      .slice(0, Object.values(DRAWER_SECTIONS).length - 1)
  )

  const history = useHistory();

  const redirectToMainRoute = () => {
    return history.push({
      pathname: ROUTER.MAIN
    })
  }

  return (
    <div className={classes.content}>
      <div className={classes.imgDiv}>
        <img
          src={Logo}
          style={{ maxHeight: '65.32px', maxWidth: '120px', cursor: 'pointer' }}
          alt='Logo'
          onClick={redirectToMainRoute}
        />
      </div>
      <div className={classes.lists}>
        <List>
          {
            sections.map((m, idx) => (
              <DrawerSection
                key={idx}
                selectedKey={selectedKey}
                {...m}
              />
            ))
          }
        </List>
        <List style={{ padding: 0 }}>
          <DrawerSection
            {...DRAWER_SECTIONS.EXIT}
            selectedKey={selectedKey}
          />
        </List>
      </div>
    </div>
  )
}

DrawerContent.propTypes = {
  onSelect: PropTypes.func,
  selectedKey: PropTypes.string,
}

DrawerContent.defaultProps = {
  onSelect: () => true
}

const styles = theme => ({
  content: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
  },
  imgDiv: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(3),
  },
  lists: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    justifyContent: 'space-between'
  },
  divider: {
    background: '#818181',
    marginLeft: '5%',
    maxWidth: '90%',
    height: '2px'
  }
})

export default withStyles(styles)(DrawerContent)